module.exports = __webpack_public_path__ + "img/questions-img.png?2868657db95da6c81cb3699c2e19564a";